import { TYPE_COLLECTION } from './input-types';
import { TAG } from '../constants';

export const id = TAG;
export const apiKey = 'tag';
export const type = TYPE_COLLECTION;

export const tag = {
  id,
  apiKey,
  type,
};
